import { render, staticRenderFns } from "./UpZipDialog.vue?vue&type=template&id=e510b4c2&scoped=true"
import script from "./UpZipDialog.vue?vue&type=script&lang=js"
export * from "./UpZipDialog.vue?vue&type=script&lang=js"
import style0 from "./UpZipDialog.vue?vue&type=style&index=0&id=e510b4c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e510b4c2",
  null
  
)

export default component.exports